"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBQm;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * SVBQm - Quantum Metric React Component
 * @param {object} props 
 */
function SVBQm(props) {
  const [enabled, setEnabled] = (0, _react.useState)(false);
  const source = props.qtmsrc || process.env.REACT_APP_QM_SRC || 'https://cdn.quantummetric.com/qscripts/quantum-svbpreprod.js';
  (0, _react.useEffect)(() => {
    if (process.env.REACT_APP_INTERNAL || props.enabled === true || localStorage.getItem('qm') === 'true') {
      setEnabled(true);
      var qtm = document.createElement('script');
      qtm.type = 'text/javascript';
      qtm.async = 1;
      qtm.src = source; // <- Variable to check
      var d = document.getElementsByTagName('script')[0];
      {
        !props.testing && !window.QuantumMetricAPI && d.parentNode.insertBefore(qtm, d);
      }
      localStorage.setItem('qm', "".concat(enabled));
    } else {
      localStorage.setItem('qm', "".concat(enabled));
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
}